<template>
  <div style="text-align: left">
    <div class="mt-3">
      <div class="container">
        <div class="header_background">
          <table>
            <tr style="width:100%;">
              <td style="width:50%;">
                <div class="sectionHead">
                  <b>All Hot Products</b>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div>
          <div class="row" style="margin-top:5%;margin-bottom:2%;">
            <div class="col-6" style="text-align: center; border: 0px solid;">
              <div class="wrapper">
                <div class="card">
                  <a href="data.ItemUrl">
                    <div>
                      <img
                        src="https://prod-site-cdn.paykoko.com/stay_tuned_Eid_613296ac79.jpg?updated_at=2022-07-20T13:07:39.019Z"
                        style="width: 100%;border-radius: 16px;"
                      />

                      <div class="discount">
                        <div class="discount-text ">
                          <span>Rs 25000</span>
                        </div>
                      </div>

                      <p class="mercText">Sample Item</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Interop vue 2 component to vue 3
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";
// import MerRectDisp from "@/components/MerRectDisp";

toVue3.register(Vue2, Vue3);

export default {
  name: "MobhotProducts",
  components: {
    // MerRectDisp,
  },
  data() {
    return {
      finalId: 0,
      cattype: "deals",
    };
  },
  created() {
    // document.title = "Deals @ Koko";
    document.title = "Buy Now Pay Later with Koko";
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll: function() {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
  },
  setup() {},
};
</script>

<style scoped>
a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

.search-wrapper {
  position: relative;
}
.search-wrapper label {
  position: absolute;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  top: 8px;
  left: 12px;
  z-index: -1;
  transition: 0.15s all ease-in-out;
}
.search-wrapper input {
  padding: 4px 12px;
  color: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: 0.15s all ease-in-out;
  background: white;
}
.search-wrapper input:focus {
  outline: none;
  transform: scale(1.05);
}
.search-wrapper input:focus + label {
  font-size: 10px;
  transform: translateY(-24px) translateX(-12px);
}
.search-wrapper input::-webkit-input-placeholder {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 100;
}
.wrapper {
  display: flex;
  max-width: 444px;
  flex-wrap: wrap;
  padding-top: 12px;
}
.card {
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  max-width: 41%;
  margin: 15px;
  border-radius: 16px;
  transition: 0.15s all ease-in-out;
}
.card:hover {
  transform: scale(1.1);
}
.card a {
  text-decoration: none;
  padding: 12px;
  color: #03a9f4;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card a img {
  height: 200px;
}
.card a small {
  font-size: 10px;
  padding: 4px;
}
.hotpink {
  background: hotpink;
}
.green {
  background: green;
}
.box {
  width: 100px;
  height: 100px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.card3 {
  display: grid;
  place-content: center;
  font-size: 1.5rem;
  height: 100%;
  width: 137px;
  margin-top: 17%;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  border-radius: 16px;
  margin-left: 10%;
}
.mercText {
  font-family: Raleway;
  font-style: normal;
  font-weight: 200;
  font-size: 13px;
  color: #393939;
  margin-top: 2%;
  margin-left: 1%;
  margin-right: 1%;
}

.discount {
  position: relative;
  z-index: 1000;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  border-radius: 16px;
  margin-top: -8%;
  width: 147px;
}
.discount .discount-text {
  color: #fff;
  background: #242424;
  font-size: 13px;
  padding: 8px;
  font-weight: bold;
  font-family: Raleway;
  border-radius: 16px;
}
.discount .discount-text span {
  display: block;
  font-size: 11px;
}
</style>
